import React, { useContext } from 'react';

import LoadingPage from '../../../components/LoadingPage';
import ManageTrackContext from './ManageTrackContext';
import ManageTrackContextProvider from './ManageTrackContextProvider';

/**
 * Inserts ManageTrackContextProvider.
 *
 * @param {Object} Component The component that needs the context provider.
 * @returns {Object} The component to render wrapped with the provider.
 */
const withManageTrackContextProvider = (Component) => (props) => (
  <ManageTrackContextProvider>
    <Component {...props} />
  </ManageTrackContextProvider>
);

const withManageTrackContextReady = (Component) => (props) => {
  const { isReady } = useContext(ManageTrackContext);

  return isReady ? <Component {...props} /> : <LoadingPage />;
};

export {
  withManageTrackContextProvider,
  withManageTrackContextReady,
};
